const rutasInventario = [
  //Inventario
  {
    name: "mascarasInventario",
    type: "gltfModel",
    path: "modelos/mascaras/NOMENCLATURA.gltf",
  },
  {
    name: "mascarasZonas",
    type: "gltfModel",
    path: "modelos/mascaras/mascaras_zonas.glb",
  },
  {
    name: "inventario",
    type: "json",
    path: "inventario/inventarioMuestra.json",
  },
]

export default rutasInventario;